import React, { Component } from 'react';
import './index.scss';
import { getCompanyType, getToken } from 'Utils/storage';
import { SAAS_AUTH_URL } from 'Utils/api';
import { SEEKER_VALUE } from 'Constants/commonConstants';
import { ReactComponent as SclenIcon } from './icons/sclenLogo.svg';
import { ReactComponent as SclenAIIcon } from './icons/sclenAILogo.svg';
import { ReactComponent as TEGIcon } from './icons/tegLogo.svg';
import { ReactComponent as TransportEGIcon } from './icons/transportEGLogo.svg';

class ChooseAppScreen extends Component {

    navigateToSaas = () => {
        const token = getToken()
        location.href = `${SAAS_AUTH_URL}/tegRedirect?token=${token}`;
    }

    navigateToTeg = () => {
        localStorage.setItem('teg-component', true);
        window.location.href = getCompanyType() === SEEKER_VALUE ? "/seeker" : "/transporters";
    }

  render() {
    return (
        <div className="chooseAppMain">
      <div className="choose-app-container">
        <div className="choose-card">
          <h2 className="choose-heading">Continue by Choosing</h2>
          <div className="app-options">
            <div className="app-box" onClick={() => this.navigateToSaas()}>
                <div><SclenIcon className='wt-50 ht-80'/></div>
                <div><SclenAIIcon className='wt-150 ht-50'/></div>
              
            </div>
            <div className="app-box" onClick={() => this.navigateToTeg()}>
                <div><TEGIcon className='wt-80 ht-80'/></div>
                <div><TransportEGIcon className='wt-150 ht-40'/></div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

export default ChooseAppScreen;
